import { useEffect } from 'react';

const APP_SCHEME        = 'mmstudio://';
const IOS_STORE_URL     = 'https://apps.apple.com/app/6748879356';
const ANDROID_STORE_URL = 'https://play.google.com/store/apps/details?id=com.makemoneystudio.isf';

const AppStorePage = () => {
  useEffect(() => {
    const ua = navigator.userAgent || '';
    const isIOS     = /iPad|iPhone|iPod/i.test(ua) && !window.MSStream;
    const isAndroid = /android/i.test(ua);

    if (isIOS) {
      const timer = setTimeout(() => {
        window.location.replace(IOS_STORE_URL);
      }, 1500);

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          clearTimeout(timer);
          // 앱이 열렸을 때 브라우저 탭은 stockMain으로
          window.location.replace('/stockMain');
        }
      }, { once: true });

      window.location.href = APP_SCHEME;

    } else if (isAndroid) {
      const intentUrl = `intent://open#Intent;scheme=mmstudio;package=com.makemoneystudio.isf;S.browser_fallback_url=${encodeURIComponent(ANDROID_STORE_URL)};end`;
      window.location.replace(intentUrl);

    } else {
      window.location.replace('/stockMain');
    }
  }, []);

  return null;
};

export default AppStorePage;
